export default {
    search: 'пошук',
    enter_the_city: 'введіть місто',
    to_download: 'завантажити',
    make_an_appointment: 'призначати зустріч',
    only_with: 'тільки з',
    calculate_route: 'прокласти маршрут',
    e_conference: 'є-конференція',
    safe_appointment: 'безпечна зустріч'
}
